import { Text, TextAs, TextSizes } from '@clockout-dev/design-elements';
import UserStatePill from '../userStatePill/UserStatePill';
import { formatTimestampWithZone } from '../../../utils/datetime';
import { getEventKindLabel, getEventStatusDisplay } from './payrollConnections.constants';
import styles from './styles/payroll-connections.module.scss';

/**
 * One event in a connection record.
 *
 * Two lines so the row survives the 33% page rail — timestamp and outcome pill
 * on the first, what happened plus any error reason on the second. Both the
 * card's five-row preview and the full-history modal render this same row, so
 * an event cannot read one way in one surface and another way in the other.
 *
 * The whole event is accepted rather than pre-read fields: what a row shows is
 * this component's business, and passing `timestamp`/`label`/`tone` would move
 * that decision back into every caller.
 *
 * @param {Object} props
 * @param {Object} props.event One event from the connection record.
 */
function PayrollConnectionEventRow({ event }) {
    // Outcome comes from `status`, never from `kind` — one sync row fans out
    // into several events and `complete` covers COMPLETE, PARTIAL and RETRY
    // alike.
    const outcome = getEventStatusDisplay(event?.status);

    return (
        <li className={styles.eventRow}>
            <div className={styles.eventTopLine}>
                <Text as={TextAs.SPAN} size={TextSizes.SMALL} className={styles.eventTimestamp}>
                    {formatTimestampWithZone(event?.at)}
                </Text>
                <UserStatePill tone={outcome.tone} label={outcome.label} />
            </div>
            <div className={styles.eventBottomLine}>
                <Text as={TextAs.SPAN} size={TextSizes.EXTRA_SMALL} className={styles.eventKind}>
                    {getEventKindLabel(event?.kind)}
                </Text>
                {event?.error ? (
                    <Text as={TextAs.SPAN} size={TextSizes.EXTRA_SMALL} className={styles.eventError}>
                        {event.error}
                    </Text>
                ) : null}
            </div>
        </li>
    );
}

export default PayrollConnectionEventRow;
